import React, { useState } from 'react';
import {
  FacebookShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookIcon,
  WhatsappIcon,
  LinkedinIcon,
  XIcon
} from 'react-share';
import { Share2, Check, Copy } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const shareTranslations = {
  en: { share: "Share", copied: "Link copied!" },
  ro: { share: "Distribuie", copied: "Link copiat!" },
  es: { share: "Compartir", copied: "¡Enlace copiado!" },
  it: { share: "Condividi", copied: "Link copiato!" },
  de: { share: "Teilen", copied: "Link kopiert!" }
};

const ShareButtons = ({ url, title, description, className = '' }) => {
  const { language } = useLanguage();
  const t = shareTranslations[language] || shareTranslations['en'];
  const [copied, setCopied] = useState(false);

  const shareUrl = url || window.location.href;
  const shareTitle = title || 'Live Well~Live Good~Live Long';
  const shareDescription = description || 'Discover LifeWave phototherapy patches';

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy link:', err);
    }
  };

  return (
    <div className={`flex flex-col items-center gap-3 ${className}`}>
      <div className="flex items-center gap-2 text-slate-600 text-sm font-medium">
        <Share2 className="w-4 h-4" />
        <span>{t.share}</span>
      </div>
      
      <div className="flex items-center gap-2">
        <FacebookShareButton url={shareUrl} hashtag="#LifeWave">
          <FacebookIcon size={40} round className="hover:opacity-80 transition-opacity" />
        </FacebookShareButton>

        <WhatsappShareButton url={shareUrl} title={`${shareTitle}\n\n${shareDescription}`}>
          <WhatsappIcon size={40} round className="hover:opacity-80 transition-opacity" />
        </WhatsappShareButton>

        <LinkedinShareButton url={shareUrl} title={shareTitle} summary={shareDescription}>
          <LinkedinIcon size={40} round className="hover:opacity-80 transition-opacity" />
        </LinkedinShareButton>

        <TwitterShareButton url={shareUrl} title={shareTitle} hashtags={['LifeWave', 'Wellness']}>
          <XIcon size={40} round className="hover:opacity-80 transition-opacity" />
        </TwitterShareButton>

        <button
          onClick={handleCopyLink}
          className="w-10 h-10 rounded-full bg-slate-200 hover:bg-slate-300 flex items-center justify-center transition-colors"
          title={copied ? t.copied : 'Copy Link'}
          data-testid="share-copy-link"
        >
          {copied ? (
            <Check className="w-5 h-5 text-green-600" />
          ) : (
            <Copy className="w-5 h-5 text-slate-600" />
          )}
        </button>
      </div>
      
      {copied && (
        <span className="text-green-600 text-sm font-medium animate-fade-in">
          {t.copied}
        </span>
      )}
    </div>
  );
};

export default ShareButtons;
